import {KTSVG} from '_metronic/helpers'
import {simpleCurrency} from 'app/format/currency'
import clsx from 'clsx'
import React, {FC} from 'react'

type Props = {
  shippingMethod: any
  selectedShippingMethod: any
  onShippingRateChange: (value: any) => void
}

export const ShippingRateList: FC<Props> = ({
  shippingMethod,
  selectedShippingMethod,
  onShippingRateChange,
}) => {
  const handleChange = () => {
    const shipping = {
      ...shippingMethod,
      serviceId: shippingMethod.rateClassId,
      carrierType: shippingMethod.carrierType,
      price: shippingMethod.rate,
      title: shippingMethod.serviceName,
    }
    onShippingRateChange(shipping)
  }
  return (
    <>
      <label
        className={clsx(
          'd-flex flex-stack mb-7 cursor-pointer border-3 border rounded py-3',
          shippingMethod.rateClassId === selectedShippingMethod
            ? 'border-primary-active bg-light-primary'
            : ''
        )}
      >
        <div className='d-flex gap-8 w-100'>
          <div className='d-flex align-items-center me-4'>
            <div className='form-check form-check-custom ms-4'>
              <input
                className='form-check-input form-check-xs ms-5'
                type='radio'
                name='shippingMethod'
                checked={shippingMethod.rateClassId === selectedShippingMethod}
                value={shippingMethod.rateClassId}
                onChange={handleChange}
                // disabled={isSubmitting.create}
              />
            </div>
          </div>

          <div className=' my-2 col-2 d-flex align-items-start flex-column'>
            {shippingMethod.discount > 0 && (
              <s className='me-2 text-danger'>{simpleCurrency(shippingMethod.originalRate)}</s>
            )}
            <span>{simpleCurrency(shippingMethod.rate)}</span>
          </div>

          <div className='d-flex justify-content-start w-100 col'>
            <span className='d-flex align-items-center me-2'>
              <span className='d-flex flex-column'>
                <span className='fs-6 service_name'>{renderHTML(shippingMethod.serviceName)}</span>

                {shippingMethod.description ? (
                  <span className='fs-7 text-muted'>
                    {renderHTML(getBusinessDays(shippingMethod.description))}
                  </span>
                ) : null}
              </span>
            </span>
          </div>
          <div className='d-flex justify-content-end ps-3'>
            <KTSVG
              path={`/media/icons/corksy/rates/${shippingMethod.carrierType}.svg`}
              className='svg-icon-5hx'
            />
          </div>
        </div>
      </label>
    </>
  )
}
export default ShippingRateList

const renderHTML = (rawHTML: any) =>
  React.createElement('span', {dangerouslySetInnerHTML: {__html: rawHTML}})

const getBusinessDays = (_description: string) => {
  let days
  if (_description) {
    const description = _description.match(/\d+/g)
    if (description && description.length) {
      days = `(${description[0]} - ${description[1]} days)`
    }
  }
  return days
}
